exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Montserrat|Signika);", ""]);

// module
exports.push([module.id, "#app{font-family:Montserrat,Helvetica,Arial,sans-serif;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;text-align:center;color:#2d2d2d;margin:5vmax 7.5vmax}h1,h2{font-weight:400;font-family:Signika}.fest-button{margin:1em}.center{text-align:center}.padded{margin-top:.75em}.extra-padded{margin-top:3em}#userImg{max-width:7.5vw;max-height:7.5vw;border-radius:5px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-05e3b288","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = 347
// module chunks = 0